/**
 * Generates an array of numbers in a given range.
 *
 * @param {number} start - The start of the range (inclusive).
 * @param {number} end - The end of the range (inclusive).
 * @returns {number[]} An array of numbers in the range.
 */
const range = (start, end) => {
  const length = end + 1 - start;
  return Array.from(Array(length).keys()).map(key => key + start);
};

export { range };
